
<div class="mainBG">

    <div class="white container-fluid mainContent">
        <div class="lock-screen">
            <div class="animate fadeIn text-center">
                <!-- added 'row' class -->
                <div class="row">
                    <div class="col-md-7 px-0">
                        <!-- replaced 'img-responsive' class with 'img-fluid' -->
                        <img src="assets/images/Left_Img.png" height="550px" class="img-fluid" style="height: 550px;">
                    </div>

                    <div class="col-md-5 p-0 bottom-align1 bg-white roundedRight">
                        <div class="col-md-12">
                            <!-- added 'row' class -->
                            <div class="row mb-10 justify-content-lg-center">
                                <!-- *ngIf="loginservice && loginservice.hideGebbsLogo==false" -->

                                <span class="col-md-6">
                                    <div class="mt-5">
                                        <!-- replaced 'img-responsive' class with 'img-fluid' -->
                                        <img src="assets/images/iAR.png" width="98px" height="66px">
                                    </div>
                                </span>
                            </div>
                            <!-- <div class="col-md-12 text-center version-text"> Version: {{version}}</div>
                            <div class="col-md-12 text-center version-text"> Released Version: {{ReleasedVersion}}</div> -->

                             <div class="col-md-12 text-center version-text" style="color: #3579b1;font-size: 16px;top: 65px;"> Forgot Password       </div>

                        </div>

                       <form *ngIf="!SwitchToReset" [formGroup]="MyForm" (ngSubmit)="ForgotSubmit()" style="top: 95px;
                       position: relative; left: 10px;">
                        <div class="col-md-12 ">
                            <!-- <div class="form-group">
                                <label for="Uname" class="label-std control-label p-0 b-600">Username</label>
                                <input required type="text" maxlength="20" class="form-control" formControlName="username" name="username" id="Uname" placeholder="Username">
                                <div class="error" *ngI f="MyForm.get('username').hasError('required') && DisplayError">
                                    Username is required.
                                </div>
                            </div> -->

                              <div class="form-item">
                                <input type="text" required type="text" maxlength="20" formControlName="username"
                                name="username" id="username" style="left: 100px;"
                                 [ngClass]="{'input-error': MyForm.get('username').hasError('required') && DisplayError}">
                                <label for="username" style="left: 105px;">Username</label>
                                <span class="fa fa-exclamation-circle errspan" *ngIf="MyForm.get('username').hasError('required') && DisplayError" title="Username is required"></span>
                            </div>

                        </div>
                        <div class="col-md-8 mt-10" *ngIf="MyForm.controls.captchaData as captcha" style="align-items:center;display: contents;">
                            <div class="form-group" style="margin-bottom: 0;width: 280px;left: 75px;position: relative;">
                                <div class="captchaContainer">
                                  <img [src]="showCaptcha" alt="captcha" style="height: 50px;width: 200px;" class="captcha">
                                    <div class="controls">
                                        <div class="">
                                            <input class="valid capinput form-control" formControlName="captchaData" type="text" placeholder="Type above text" style="width: 98%;"
                                            [ngClass]="{'input-error': MyForm.get('captchaData').hasError('required') && DisplayError}">
                                            <span class="errorSection" *ngIf="captcha.touched==true || DisplayError">
                                                <!-- <div class="error"
                                                *ngIf="MyForm.get('captchaData').hasError('required') && DisplayError">
                                                    Captcha is required.
                                                </div> -->
                                            </span>
                                        </div>
                                        <button title="Refresh Captcha Code" style="height: 28px;" type="button" class="btn btn-primary" (click)="callCaptcha()">
                                          <i [ngClass]="{'rotate': isCaptcha == true}" class="fa fa-refresh"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 mt-10 text-center">
                            <button type="submit" [disabled]="DisableSubmit" style="width: 195px;    position: relative;
    right: 10px;" class="btn blue square-btn blue-hover btn-txt btn-default">Submit</button>
                        </div>
                    </form>

                        <div *ngIf="!loginservice.isHideGebbsLogo" class="col-12 text-center mt-5" style="position: relative;top:25%;">
                             <span>Released Version: {{ReleasedVersion}}</span><br>
                            <span>Copyright &copy; {{CurrentYear}} GeBBS Healthcare Solutions |
                                <span><a style="cursor: pointer;" class="text-primary focus" (click)="ShowCopyright()">Disclaimer</a></span>
                            </span>
                        </div>
                    </div>
                </div>

                <div class="row justify-content-center text-white py-2" style="font-size: 10px;">
                    <p><b>Security Notice:</b> You are using a secure web connection. Your password will be encrypted in transit to our web server, but will remain on your
                        browser until you exit it.
                    </p>
                </div>

            </div>
        </div>


    </div>
</div>




  <div class="modal fade bd-example-modal-lg" id="myModal" role="dialog" [ngClass]="[showCopyright == true ? 'showmodal' : 'hidemodal']">
    <div class="modal-dialog"style="max-width: 750px!important;">
               <div class="modal-content modalContent" style="margin-top: 20rem;">
                  <div class=" modalHeader" style="text-align: center;">
                <button type="button" class="close closebtn"data-dismiss="modal"
                    (click)="closeCopyright()">&times;</button>
                <h4 style="font-size: 19px;
                font-weight: 700;" class="modal-title"><i class="fa fa-warning"></i> UNAUTHORIZED ACCESS TO THIS
                    SERVICE IS PROHIBITED.</h4>
            </div>
            <div class="modal-body">


                <div class="disclaimer-text" style="font-size: 11px; line-height: 16px; text-align: justify;">
                    <p class="para" style="text-align: center;">
                        <span style="font-weight: 700;">PLEASE READ THE TERMS AND CONDITIONS :</span>
                        <br> <br>
                        <span style="text-align: center;">iAR is confidential and proprietary, and is for authorized users only. All authorized users are subject to contractual use restrictions and nondisclosure requirements that prevent giving access to third parties. Unauthorized users are subject to prosecution, lawsuits, and penalties under state and federal law. All system activities are monitored, recorded and reviewed by system personnel. Anyone using this system expressly consents to such monitoring and is hereby warned that if such monitoring reveals possible evidence of criminal activity by the user, the same shall be reported to law enforcement Agency. Provider reserves the right, at its sole discretion, to change, modify the software or program at any time without notice. Any rights not expressly granted herein are reserved.
                        </span><br> <br> <br>
                       <span style="font-weight: 700;">Contact: Infosec Team - infosec&#64;gebbs.com</span>

                    </p>
                </div>
            </div>
            <div class="modal-footer"style="display: inline;">
                <button type="button" class="btn btn-default blue square-btn blue-hover btn-txt"(click)="closeCopyright()" style="margin-left:45%;font-size: 1.3rem;" data-dismiss="modal">Close
                    </button>
            </div>
        </div>

    </div>
</div>